import React, { ReactElement } from 'react';
import { Helmet } from 'react-helmet';
import { ThemeProvider } from '@material-ui/core/styles';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import theme from '../../theme';
import AppContainer from '../AppContainer';
import ScrollToTop from '../ScrollToTop';
// Pages
import Home from '../../pages/Home';
import ProjectPage from '../../pages/Projects';
import ServicePage from '../../pages/Services';
import ContactPage from '../../pages/Contact';
import NewsPage from '../../pages/News';

function App(): ReactElement {
    return (
        <ThemeProvider theme={theme}>
            <Router>
                <ScrollToTop />
                <Helmet>
                    <title>London Insulation Services</title>
                </Helmet>
                <AppContainer>
                    <Switch>
                        <Route exact path="/">
                            <Home />
                        </Route>
                        <Route path="/projects">
                            <ProjectPage />
                        </Route>
                        <Route path="/services">
                            <ServicePage />
                        </Route>
                        <Route path="/contact">
                            <ContactPage />
                        </Route>
                        <Route path="/news">
                            <NewsPage />
                        </Route>
                    </Switch>
                </AppContainer>
            </Router>
        </ThemeProvider>
    );
}

export default App;
